enum EListType {
  Horizontal = 1,
  Vertical = 2,
}

export default EListType
